export function flattenIds(notifications) {
    if (!Array.isArray(notifications)) {
        notifications = [notifications];
    }
    return notifications.reduce(function (acc, n) {
        if (n.aggregated) {
            var subIds = n.subNotifications.map(function (subId) { return ({
                eventId: subId,
                // for now, assumption is that we'll only have 1 marketplaceId - need to update in the future if this assumption changes
                marketplaceId: n.marketplaceIdList ? n.marketplaceIdList[0] : undefined
            }); });
            return acc.concat(subIds);
        }
        else {
            acc.push({
                eventId: n.eventId,
                // for now, assumption is that we'll only have 1 marketplaceId - need to update in the future if this assumption changes
                marketplaceId: n.marketplaceIdList ? n.marketplaceIdList[0] : undefined
            });
            return acc;
        }
    }, []);
}
